import React from 'react';

export default function Coke() {
  return (
    <div className="Coke">
      <iframe src="https://player.vimeo.com/video/481467199" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>   
    </div>
  );
}